import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, defer, timer, switchMap, map, expand } from 'rxjs';
import { GetDataSourceResponse } from 'src/app/models/data-source.interface';

@Injectable({
  providedIn: 'root',
})
export class DataSourceService {
  apiAddress: string = environment.apiAddress;

  constructor(private http: HttpClient) {}

  getDataSources(id: string): Observable<GetDataSourceResponse[]> {
    return this.http
      .get<{ code: string; data: GetDataSourceResponse[] }>(`${this.apiAddress}/bot/${id}/sources`)
      .pipe(map((response) => response.data));
  }

  /**
   * Polls all datasources with exponential backoff.
   * Intervals: 3s → 6s → 12s → 24s → 30s (cap).
   * Consumer must add takeWhile() to stop the stream.
   */
  pollDataSources(botId: string): Observable<GetDataSourceResponse[]> {
    const baseInterval = 3000;
    const maxInterval = 30000;

    return defer(() => {
      let attempt = 0;
      return this.getDataSources(botId).pipe(
        expand(() => {
          const wait = Math.min(baseInterval * Math.pow(2, attempt), maxInterval);
          attempt++;
          return timer(wait).pipe(switchMap(() => this.getDataSources(botId)));
        })
      );
    });
  }

  deleteDataSource(botId: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.apiAddress}/bot/${botId}/source/${id}`);
  }

  downloadFileFromGDrive(
    botId: string,
    fileId: string,
    mimeType: string,
    fileName: string,
    accessToken: string
  ): Observable<any> {
    return this.http.post(`${this.apiAddress}/bot/${botId}/source_upload/gdrive`, {
      file_id: fileId,
      mime_type: mimeType,
      file_name: fileName,
      access_token: accessToken,
    });
  }
}
